import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'
import AsyncStorage from '@react-native-async-storage/async-storage'

interface UseDarkModeState {
  darkMode: boolean
  switchMode: () => void
}

export const useDarkModeStore = create<UseDarkModeState>()(
  persist(
    (set) => ({
      darkMode: false,
      switchMode: () => set((state) => ({ darkMode: !state.darkMode })),
    }),
    { name: 'darkModeStore', storage: createJSONStorage(() => AsyncStorage) },
  ),
)
